import { useState, useEffect } from 'react';
import PermissionService from '../../../services/permission_service';
import RolePermissionService from '../../../services/rolePermission_service';

const PermissionsRole = (props) => {
  const [permissionsRoles, setPermissionsRoles] = useState([]);  
  const [permissionsSave, setPermissionsSave] = useState([]);

  const loadPermissions = async () => {
    try {
      props.setLoading(true);
      if (props.role?.Id) {
        const permissions = await PermissionService.getByRole(props.role?.Id);
        if (props.logout(permissions)) return;
        setPermissionsRoles(permissions || []);
      }
    } catch (e) {
      props.message(e?.message || e, "error");
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {loadPermissions()}, [props.role]);

  const changeSave = async () => {
    props.setLoading(true);
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) {
      props.setLoading(false);
      return;
    }
    try {
      const deleted = await RolePermissionService.replace({
        FK_Role: props.role?.Id,
        permissions: permissionsSave
      });
      if (props.logout(deleted)) return;
      props.message("Permisos actualizados con exito", "success");
    } catch(e) {
      props.message(e?.message || e, "error")
    } finally {      
      await loadPermissions()
      props.setRole('')
    }
  }

  return {
    permissionsRoles,
    setPermissionsSave,
    setPermissionsRoles,
    changeSave
  }
};

export default PermissionsRole;
